import React, { useState } from "react";
import backBtn from "../../assets/images/backBtn.svg";
import backBtnMobile from "../../assets/images/backBtnMobile.svg";
import { useLocation, useNavigate } from "react-router-dom";
import breadcrumb from "../../assets/images/breadcrumb.svg";
import { Breadcrumb } from "antd";
import { useTranslation } from "react-i18next";
import { setItem } from "../../common/localStorage";
// import ReactReadMoreReadLess from "react-read-more-read-less";
// import ShowMoreText from "react-show-more-text";

const HealthQuiz = () => {
  const [expandedIndexes, setExpandedIndexes] = useState([]);
  const toggleExpand = (index) => {
    setExpandedIndexes((prevState) =>
      prevState.includes(index)
        ? prevState.filter((i) => i !== index)
        : [...prevState, index]
    );
  };
  const navigate = useNavigate();

  const { state } = useLocation();
  const { t } = useTranslation();

  const navigateToQuizList = (quizDataItem) => {
    navigate("/quiz-list", { state: state,getPendingMonthsSelector:state?.getPendingMonthsSelector });
    setItem("quizDetails",quizDataItem)
  };

  return (
    <>
      <div className="py-50 mobileMargin">
        <div className="container">
          <div className="doctorGrid">
            {state?.item?.quizData?.map((quizDataItem, quizDataIndex) => {
              const isExpanded = expandedIndexes.includes(quizDataIndex);
              const characterLimit = quizDataItem?.quizDescription?.length;
              return (
                <>
                  <div className="doctorCard" key={quizDataIndex}>
                    <div className="fs-20 tgb mb-10">
                      {quizDataItem?.quizName}
                    </div>
                    <div className="l15 mb-32">
                      <div
                        className={`content-css ${
                          isExpanded ? "expanded" : "collapsed"
                        }`}
                      >
                        {!isExpanded
                          ? quizDataItem?.quizDescription
                          : quizDataItem?.quizDescription?.slice(0, 100)}
                      </div>
                      {characterLimit > 120 && (
                        <div
                          className="show-more-less-clickable"
                          onClick={() => toggleExpand(quizDataIndex)}
                        >
                          {!isExpanded ? t("View less") : t("View more")}
                        </div>
                      )}
                    </div>
                    <button
                      className="startBtn cursor-pointer"
                      onClick={()=>navigateToQuizList(quizDataItem)}
                    >
                      {t("Take a Quiz")}
                    </button>
                  </div>
                </>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default HealthQuiz;
